var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.minutes > 0)?_c('span',[_vm._v(_vm._s(_vm.minutes)+" m.")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.seconds)+" s.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }